import { FilterFn } from "@tanstack/react-table";
import { filterFns } from "@tanstack/table-core";
import { prettifyEnumLabel } from "../../../core";
import { ApplyTablePredefinedFilterOptions, PrettifyFilterValueSignature } from "../types";

export function applyPredefinedFilter<TData extends object, TPredefinedFilter extends (v: TData) => boolean>(
  {
    data,
    filter,
  }: ApplyTablePredefinedFilterOptions<TData, TPredefinedFilter>) {
  return data?.filter(filter)?.length;
}

export function getPrettifyFilterValue<T = any>(getLabel = (v: T) => v?.toString?.() || ""): PrettifyFilterValueSignature<T> {
  return (value, filterFn) => {
    return ({
      value: Array.isArray(value) ? getLabel(value[0]) : getLabel(value as T),
      badgeValue: Array.isArray(value) ? `+ ${value.length - 1}` : undefined,
    });
  };
}

export const defaultPrettifyFilterValue = getPrettifyFilterValue();

export function defaultPrettifyFilterOperatorLabel<TData extends object>(filterFn: FilterFn<TData>) {

  let baseLabel:any = filterFn;

  if (typeof filterFn === "function") {
    const defaultFunction = Object.entries(filterFns)
      .find(([ key, value ]) => value === filterFn);

    if (defaultFunction) {
      baseLabel = defaultFunction[0];
    }
  }

  if (baseLabel === "inNumberRange") {
    baseLabel = "between"
  }

  if (baseLabel.toString().includes("includesString")){
    baseLabel = baseLabel.replace("includesString", "includes");
  }

  if (baseLabel.toString().includes("arrIncludes")){
    baseLabel = baseLabel.replace("arrIncludes", "contains");
  }

  return prettifyEnumLabel(baseLabel);
}